import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/artists';

export default function CategoriesSection() {
  const { t } = useTranslation('home');

  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-10 lg:px-16 bg-white">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 lg:gap-8 mb-10 md:mb-14">
        <div className="lg:max-w-md">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            {t('categories.title')}
            <br />
            {t('categories.titleLine2')}
            <br />
            {t('categories.titleLine3')}
          </h2>
        </div>
        <div className="lg:max-w-sm lg:pt-2">
          <p className="text-sm md:text-base text-gray-500 leading-relaxed">
            {t('categories.description')}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {categories.slice(0, 6).map((cat, index) => (
          <Link
            key={cat.id}
            to={`/artistas?categoria=${cat.slug}`}
            className={`group relative overflow-hidden rounded-2xl md:rounded-3xl bg-gray-50 hover:bg-gray-100 transition-all ${
              index === 0 ? 'sm:col-span-2 lg:col-span-1 lg:row-span-2' : ''
            }`}
          >
            <div className={`relative overflow-hidden ${index === 0 ? 'aspect-[4/3] lg:aspect-auto lg:h-full' : 'aspect-[4/3]'}`}>
              <img
                src={cat.imageUrl}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
                    <i className={`${cat.icon} text-white text-xs md:text-sm`}></i>
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-white">{cat.name}</h3>
                </div>
                <p className="text-xs md:text-sm text-white/70 leading-relaxed max-w-xs">{cat.description}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-6 md:mt-8 flex justify-center">
        <Link
          to="/artistas"
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-gray-700 border border-gray-200 rounded-full hover:bg-gray-900 hover:text-white hover:border-gray-900 transition-all whitespace-nowrap"
        >
          {t('categories.viewAll')}
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      </div>
    </section>
  );
}